import BaseLayout from 'src/layouts/BaseLayout'
import SchoolListCell from 'src/components/SchoolListCell'
import { Flex, Box, Divider } from '@chakra-ui/react'
import LogCell from 'src/components/LogCell'
import { useParams } from 'react-router-dom'

const LogPage = () => {
  const { page } = useParams()
  return (
    <BaseLayout>
      <Flex>
        <Box minWidth={300} maxWidth={300}>
          <SchoolListCell selected={null} />
        </Box>
        <Divider orientation="vertical" marginX={0} />
        <LogCell page={page || 1} />
      </Flex>
    </BaseLayout>
  )
}

export default LogPage
